<template>
	<div>
		<!--header-->
		<app-header :headerTitle="siteTitle"></app-header>

		<!--loading-->
		<div class="loading text-center px-3" v-if="loading">
			<div class="alert alert-blue d-inline-block py-2 px-3">
				<i class="fa fa-refresh fa-spin ml-1 align-middle"></i> در حال بارگذاری ...
			</div>
		</div>

		<div v-else>
			<!--reload message-->
			<div class="message px-3 text-center" v-if="message">
				<div class="alert alert-warning">
					{{ message }}
				</div>
				<a class="btn btn-green" @click="$router.go(0)" v-if="!inquiry">
					بارگذاری دوباره
				</a>
			</div>

			<!--product-->
			<div class="product text-center" v-else>
				<!--images-->
				<div class="product-image-container" v-if="images && images.length == 1">
					<img :src="product.images[0].path+'?m=thumb&h=250'" class="img-fluid mx-auto d-block">
				</div>
				<carousel :data="images" 
					indicator-type="disc"
					:controls="false" v-if="images && images.length > 1">
				</carousel>

				<!--title-->
				<h1 class="product-title px-3">
					{{ title }}
				</h1>

				<!--caption-->
				<h5 class="product-caption text-secondary px-3">
					{{ caption }}
				</h5>

				<!--attributes-->
				<div class="product-attributes px-3" v-if="attributes">
					<div class="form-group" :key="attribute.name" v-for="(attribute, i) in attributes">
						<div class="input-group">
							<div class="input-group-prepend">
								<div class="input-group-text">
									{{ attribute.name }}
								</div>
							</div>
							<select class="form-control" @change="checkAttribute()"
								v-model="attributeItem[i]"
								:disabled="progress"
								:class="{'error': $v.attributeItem.$each[i].$error}">
								<option value="" v-if="!attributeItem[i]">---</option>
								<option :key="value" v-for="(key, value) in attribute.values" :value="key">
									{{ key }}
								</option>
							</select>
						</div>
						<div class="form-error mt-2 mb-3" v-if="$v.attributeItem.$each[i].$error">لطفا {{ attribute.name }} را انتخاب کنید.</div>
					</div>
				</div>

				<!-- quantity -->
				<div class="product-quantity px-3" v-if="available">
					<hr>
					<div class="form-group">
						<div class="input-group">
							<div class="input-group-prepend">
								<div class="input-group-text">
									تعداد
								</div>
							</div>
							<input type="number" class="form-control"
								v-model="quantity"
								:min="1"
								:max="maxquantity"
								:disabled="progress"
								:class="{'error': $v.quantity.$error || quantity > maxquantity || quantity < minquantity || quantity > stock}">
						</div>
					</div>
					<div class="form-error mt-2 mb-3" v-if="!$v.quantity.required">لطفا تعداد را وارد کنید.</div>
					<div class="form-error mt-2 mb-3" v-if="!$v.quantity.minValue">تعداد محصول نمی‌تواند کمتر از {{minquantity}} باشد.</div>
					<div class="form-error mt-2 mb-3" v-if="!$v.quantity.maxValue">تعداد محصول نمی‌تواند بیشتر از {{maxquantity}} باشد.</div>
					<div class="form-error mt-2 mb-3" v-if="quantity > stock">موجودی کافی نمی‌باشد.</div>
				</div>

				<div class="product-outofstock alert alert-warning m-3 p-2" v-if="!available">
					محصول مورد نظر موجود نمی‌باشد.
				</div>

				<!--info-->
				<div class="product-info">
					<h4 class="product-price text-center" v-if="price">
						<div v-if="compare_price">
							<s class="product-compareprice text-secondary">{{ formatPrice(compare_price * quantity) }} <small>تومان</small></s>
						</div>
						{{ formatPrice(price * quantity) }} <small>تومان</small>
					</h4>
					<div class="text-center">
						<span class="product-discount btn" v-if="discount && discount != 0">
							{{ discount }} تخفیف
						</span>
					</div>
				</div>

				<!--add to cart-->
				<button type="button" class="product-addtocart btn btn-green btn-lg btn-block position-fixed py-3"
					@click="addToCart()">
						<i class="fa fa-shopping-cart"></i>
						{{ progress ? 'کمی صبر کنید ...': 'خرید محصول' }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "../components/Header.vue"
	import axios from "axios"
	import { required, minValue, maxValue } from 'vuelidate/lib/validators'
	export default {
		components: {
			appHeader: Header
		},
		data() {
			return {
				loading: true,
				progress: null,
				message: null,
				submitStatus: null,
				inquiry: false,
				apiErrors: [],
				siteTitle: "",
				cart: {},
				product: [],
				images: [],
				title: "",
				caption: "",
				price: "",
				compare_price: "",
				discount: 0,
				quantity: 1,
				minquantity: 1,
				maxquantity: 100,
				stock: 1000000,
				available: true,
				attributes: [],
				attributeItem: [],
				selectedVariantsData: {},
				variantID: "",
				addToCartRes: []
			}
		},
		validations() {
			if(this.attributes) {
				return {
					attributeItem: {
						$each: {
							required
						}
					},
					quantity: {
						required,
						minValue: minValue(this.minquantity),
						maxValue: maxValue(this.maxquantity)
					}
				}
			} else {
				return {
					quantity: {
						required,
						minValue: minValue(this.minquantity),
						maxValue: maxValue(this.maxquantity)
					}
				}
			}
		},
		methods: {
			// discount
			discountCompute() {
				this.discount = null
				if(this.compare_price) {
					this.discount = Math.abs(Math.round(((this.price - this.compare_price)/this.compare_price)*100))+"%";
				}
			},
			// check Attribute
			checkAttribute() {
				if(this.attributes) {
					let selectedVariants = [];

					for (let i = 0; i < this.attributes.length; i++) {
						selectedVariants.push(this.attributes[i].name+': '+this.attributeItem[i]);
					}

					selectedVariants = selectedVariants.join('، ');

					for (let i = 0; i < this.product.variants.length; i++) {
						if(selectedVariants == this.product.variants[i].title) {
							this.selectedVariantsData = this.product.variants[i];
							
							// update product data
							this.price = this.selectedVariantsData.price;
							this.compare_price = this.selectedVariantsData.compare_price;
							this.available = this.selectedVariantsData.available;
							this.discountCompute();
							this.variantID = this.selectedVariantsData.id;

							if(this.selectedVariantsData.stock != null)
								this.stock = this.selectedVariantsData.stock
							
							if (this.selectedVariantsData.minimum != null) {
								this.minquantity = this.selectedVariantsData.minimum
								// this.quantity = this.selectedVariantsData.minimum
							} else {
								this.minquantity = 1
							}

							if(this.selectedVariantsData.maximum != null)
								this.maxquantity = this.selectedVariantsData.maximum
						}
					}
				}
			},
			// add to cart
			addToCart() {
				// delete cart items
				axios({
					method: "delete",
					url: "/site/api/v1/cart",
				})
				.then(response => {
					return response.data
				})
				.catch((err) => {
					this.apiErrors.push(err.response)
				});

				this.$v.$touch()
				if (this.$v.$invalid) {
					this.submitStatus = 'ERROR'
				} else {
					this.submitStatus = 'OK'
				}
				this.checkAttribute()

				if(this.submitStatus == 'OK' && this.available == true) {
					// progress
					this.progress = true

					axios({
						method: "post",
						url: "/site/api/v1/cart",
						data: {
							variant_id: this.variantID,
							quantity: this.quantity
						}
					})
					.then(response => {
						this.addToCartRes = response.data
						this.$router.push('checkout')
						// progress
						setTimeout(() => { this.progress = false }, 500)
					})
					.catch((err) => {
						this.apiErrors.push(err.response)
						this.message = "خطایی رخ داده است، لطفا دوباره تلاش کنید."
						// progress
						setTimeout(() => { this.progress = false }, 500)
					});
				}
			},
			formatPrice(value) {
				let val = (value/1).toFixed(0).replace(',', ',')
				return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			}
		},
		created () {
			// get config site data
			axios({
				method: "get",
				url: "/site/api/v1/config"
			})
			.then(response => {
				const config = response.data
				this.siteTitle = config.title
			})
			.catch((err) => {
				this.apiErrors.push(err.response)
			})
			
			// get product data
			axios({
				method: "get",
				url: "/"+this.$route.params.slug,
			})
			.then(response => {
				this.product = response.data.product;
				this.attributes = this.product.attributes;

				// attributes
				if(this.attributes) {
					for (let i = 0; i < this.attributes.length; i++) {
						this.attributeItem.push("");
					}
				}

				// images
				if(this.product.images && this.product.images.length) {
					for (let i = 0; i < this.product.images.length; i++) {
						this.images.push('<div class="product-images-container"><img class="img-fluid" src="'+this.product.images[i].path+'?m=thumb&h=250"/></div>')
					}
				}

				// inquiry
				if(this.product.inquiry == true) {
					this.inquiry = true;
					this.message = "فروش این محصول به صورت مستقیم میسر نیست، برای خرید این محصول با ما تماس بگیرید."
				}

				this.title = this.product.title
				this.caption = this.product.caption

				// initial product data
				var inStockOnce = true
				var variant
				// more than one variant
				if(this.product.variants.length > 1) {
					for(variant of this.product.variants) {
						if(variant.available && variant.stock > 0 && inStockOnce) {
							this.price = variant.price
							this.compare_price = variant.compare_price
							inStockOnce = false
						}
					}
				// one variant
				} else {
					this.price = this.product.price
					this.compare_price = this.product.compare_price
				}
				
				this.available = this.product.available
				this.variantID = this.product.variants[0].id
				
				if(this.product.stock != null)
					this.stock = this.product.stock

				if (this.product.variants[0].minimum != null) {
					this.minquantity = this.product.variants[0].minimum
					// this.quantity = this.product.variants[0].minimum
				} else {
					this.minquantity = 1
				}
				
				if(this.product.variants[0].maximum != null)
					this.maxquantity = this.product.variants[0].maximum

				this.discountCompute()

				// loading
				setTimeout(() => { this.loading = false }, 500)
			})
			.catch(response => {
				setTimeout(() => { this.loading = false }, 500)
				console.log(response)
				if(response.status == 404) {
					this.message = "فایل مورد نظر شما در سامانه پیدا نشد. لطفا از صحت آدرس نوشته شده در مرورگر اطمینان حاصل کنید.."	
				} else {
					this.message = "خطایی رخ داده است، لطفا دوباره تلاش کنید."
				}
			})
		}
	}
</script>

<style>
.message, .loading { padding-top: 100px; }
.product { padding-bottom: 100px; padding-top: 66px; }
.product-image-container { display: flex; align-items: center; justify-content: center; margin: 0 0 15px; }
.product-image-container img {  }
.product-images-container { height: 250px; display: flex; align-items: center; justify-content: center; }
.product-images-container img {  }
.carousel {  margin: 0 0 15px; }
.carousel__list {  }
.carousel__indicators { bottom: 10px !important; }
.carousel__indicator { opacity: 0.3 !important; }
.carousel__indicator--active { opacity: 1 !important; }
.carousel__indicator::before { background-color: #ccc !important; }
.carousel__indicator--active::before { background: #ff8675 !important; width: 12px !important; height: 12px !important; }
.product-title { font-size: 1.4rem; margin: 15px 0; }
.product-caption { font-size: 0.9rem; margin-bottom: 10px; }
.product-info {  }
.product-attributes { margin: 15px 0; }
.product-attributes .input-group-text { min-width: 70px; justify-content: center; }
.product-price { color: #ff8675; font-size: 1.7rem; font-weight: 700; }
.product-price > small { color: #8c8c8c; font-weight: 400; font-size: 1rem; }
.product-compareprice { font-weight: 500; font-size: 1rem; }
.product-discount { background: #ff8675; color: #fff; margin: 5px 0; }
.product-addtocart { border-radius: 0; bottom: 0; right: 0; left: 0; z-index: 10; }
.product-addtocart[disabled] { cursor: default; opacity: 1; }
</style>
